export enum Pages {
  Worksheet = 'worksheet',
  Review = 'review',
  SessionTimeout = 'session-timeout',
  Error = 'error',
  UnityDirect = 'unity-direct',
  UnityExpress = 'unity-express',
  Bundles = 'bundles',
  Billing = 'billing',
  Admin = 'admin'
}
